<template>
  <div class="commonLogin">
    <div class="container">
      <left></left>
      <div class="right">
        <form action="" class="fm">
          <p class="titleNav"><span>商家信息</span> &gt; <span>注册信息</span></p>
          <div class="item place">
            <span>所在城市</span>
            <div class="citySelect">
              <city @city="city1" />
            </div>
          </div>
          <p class="err">{{addressMsg}}</p>
          <div class="item">
            <div>
              <span>详细地址</span>
              <input type="text" placeholder="请输入详细地址" v-model="form.address">
            </div>
          </div>
          <p class="err">{{addressMsg}}</p>
          <div class="item">
            <div>
              <span>商户名称</span>
              <input type="text" placeholder="请输入商户名称" v-model="form.businessName">
            </div>
          </div>
          <p class="err">{{nameMsg}}</p>
          <div class="item">
            <div>
              <span>商户联系人</span>
              <input type="text" placeholder="请输入商户联系人" v-model="form.businessContacter">
            </div>
          </div>
          <p class="err">{{contacterMsg}}</p>
          <div class="item">
            <div class="pull">
              <span>经营类型</span>
              <input type="tel" placeholder="请选择" v-model="form.businessType" autocomplete="off" readonly="readonly" @click="showManage">
              <img class="icon" src="../../assets/images/login/xiasanjiao.png" alt="" @click="showManage">
            </div>
            <ul class="list" v-if="isManage">
              <li @click="manageItem" v-for="(item, index) in manageList" :key="index">{{item}}</li>
            </ul>
          </div>
          <p class="err">{{typeMsg}}</p>
          <div class="item">
            <div>
              <span>日单量</span>
              <input type="text" placeholder="请输入日单量" v-model="form.dailyCount">
            </div>
          </div>
          <p class="err">{{countMsg}}</p>
          <div class="item">
            <div>
              <span>客单价</span>
              <input type="text" placeholder="请输入客单价" v-model="form.avgPrice">
            </div>
          </div>
          <p class="err">{{priceMsg}}</p>
          <div class="item">
            <div class="pull">
              <span>销售平台</span>
              <input type="tel" placeholder="请选择" v-model="form.salesPlatform" autocomplete="off" readonly="readonly" @click="clickSell">
              <img class="icon" src="../../assets/images/login/xiasanjiao.png" alt="" @click="clickSell">
            </div>
            <ul class="list" v-if="isSell">
              <li @click="sellItem" v-for="(item, index) in sellList" :key="index">{{item}}</li>
            </ul>
          </div>
          <p class="err">{{salesMsg}}</p>
          <div class="shopImg">
            <p class="imgTitle">上传店铺营业执照照片：</p>
            <div class="imgInfo">
              <img :src="form.avatar" alt="">
              <div class="claim">
                <p>要求：</p>
                <p>1、清晰</p>
                <p>2、真实</p>
                <label for="file">
                  <p class="fileBtn">本地上传</p>
                </label>
                <input type="file" id="file" @change="changeImage($event)" accept="image/gif,image/jpeg,image/jpg,image/png">
              </div>
            </div>
          </div>
          <p class="err">{{imgMsg}}</p>
          <button class="btn" @click.prevent="next">下一步</button>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import '../../assets/css/login.less'
import Left from '../../components/Login/Left'
import City from '../../components/City'
import {reqMerchant, reqFileUpload} from '../../api/index'
export default {
  data () {
    return {
      form: {
        city:[], //城市
        address: '', // 地址
        businessContacter: '', // 商家联系人
        businessName: '', // 商家
        businessType: '', // 经营方式
        dailyCount: '', // 日单量
        salesPlatform: '', // 销售平台
        avgPrice: '', // 客单价
        avatar: '', // 上传照片
        idCardImgUuid: '', // 营业执照图片id
        file: '',
      },
      manageList:[], // 经营列表
      sellList: [], // 销售列表
      addressMsg: '', // 地址错误提示
      nameMsg: '', // 商家错误提示
      contacterMsg: '', // 商家联系人提示
      typeMsg: '', // 经营方式提示
      countMsg: '', // 日单量提示
      priceMsg: '', // 客单价提示
      salesMsg: '', // 销售平台提示
      imgMsg: '', // 图片提示
      bool: false,
      bool2: false,
      isManage: false, // 经营方式隐藏
      isSell: false // 销售平台隐藏
    }
  },
  created () {
    // 获取注册商家选项
    reqMerchant().then(res => {
      if(res.code === 200){
        this.manageList = (res.data.bussData.businessTypes)[0].split(/\n/)
        this.sellList = (res.data.bussData.salesPlatforms)[0].split(/\n/)
      }
    })
  },
  methods: {
    city1(data) {
      this.form.city = data
    },
    // 显示经营方式
    showManage() {
      this.isManage = !this.isManage
    },
    // 经营方式的列表
    manageItem (e) {
      this.form.businessType = e.target.innerText
      this.isManage = !this.isManage
    },
    // 显示销售平台
    clickSell () {
      this.isSell = !this.isSell
    },
    // 销售平台的列表
    sellItem (e) {
      this.form.salesPlatform = e.target.innerText
      this.isSell = !this.isSell
    },
    // 上传图片
    changeImage (e) {
      let file = e.target.files[0]
      if (file) {
        if (e.srcElement.accept.includes(file.type)) {
          this.form.file = file
          const formData = new FormData()
          formData.append('file', file)
          this.form.avatar = window.URL.createObjectURL(e.srcElement.files.item(0))
          reqFileUpload(formData).then(res => {
            if(res.code == 200) {
              this.$message({
                message: res.desc,
                type: 'success'
              })
              console.log(res.result)
              this.form.idCardImgUuid = res.result
            }
          })
        } else {
          this.$message({
            message: '图片格式不正确',
            type: 'error'
          })
        }
      }
    },
    open () {
      this.bool = !this.bool
    },
    open2 () {
      this.bool2 = !this.bool2
    },
    next () {
      const {address, businessContacter, businessName, businessType, dailyCount, avgPrice, salesPlatform, avatar} = this.form
      if(!address){
        this.addressMsg = '地址不能为空'
      }else if(!businessName) {
        this.addressMsg = ''
        this.nameMsg = '商家名称不能为空'
      }else if(!businessContacter) {
        this.nameMsg = ''
        this.contacterMsg = '商家联系人不能为空'
      }else if(!businessType) {
        this.contacterMsg = ''
        this.typeMsg = '经营类型不能为空'
      }else if(!dailyCount) {
        this.typeMsg = ''
        this.countMsg = '日单量不能为空'
      }else if(!avgPrice) {
        this.countMsg = ''
        this.priceMsg = '客单价不能为空'
      }else if(!salesPlatform){
        this.priceMsg = ''
        this.salesMsg = '销售平台不能为空'
      }else if(!avatar){
        this.imgMsg = '请上传图片'
      }else{
        this.$router.push({name:'MerchantRegister',params:this.form})
      }
    }
  },
  computed: {
    // city1(data) {
    //   console.log(data)
    // }
  },
  components: {
    Left,
    City
  }
}
</script>

<style scoped lang="less" type="text/less">
  .commonLogin{
    .container{
      overflow: hidden;
      /*右边*/
      .right{
        float: left;
        margin-top:80px;
        form{
          .titleNav{
            font-size: 20px;
            font-weight: 700;
            color:#D1D1D1;
            span:nth-of-type(1){
              font-size: 20px;
              font-weight: 700;
              color:#2FA1DE;
            }
            span:nth-of-type(2){
              font-size: 20px;
              font-weight: 700;
              color:#D1D1D1;
            }
          }
          .place {
            display: flex;
            .citySelect{
              width: 242px;
              height: 67px;
            }
          }
          .shopImg{
            margin-top:40px;
            .imgTitle{
              font-size: 16px;
            }
            .imgInfo{
              overflow: hidden;
              margin-top:20px;
              img{
                float: left;
                display: block;
                width: 150px;
                height: 150px;
                background: #ccc;
                margin-right: 20px;
              }
              .claim{
                float: left;
                max-width: 180px;
                p{
                  margin-bottom: 21px;
                  &.fileBtn{
                    width:100px;
                    height:40px;
                    background:#fff;
                    border:1px solid #999;
                    border-radius:20px;
                    font-size: 16px;
                    text-align: center;
                    line-height: 40px;
                    font-weight: 500;
                    cursor: pointer;
                  }
                }
                input{
                  display: none;
                }
              }
            }
          }
          .item{
            .pull{
              input{
                cursor: pointer;
              }
            }
            .list{
              position: absolute;
              left: 85px;
              top: 73px;
              z-index: 99;
              width: 265px;
              line-height: 35px;
              text-indent: 10px;
              background: #fff;
              box-shadow:0px 3px 21px 0px rgba(0, 0, 0, 0.25);
              li{
                border-bottom: 1px dotted #e1e1e1;
                cursor: pointer;
              }
            }
          }
          .btn {
            width: 100%;
            height: 54px;
            margin-top: 40px;
            margin-bottom: 230px;
            background: #2FA1DE;
            color: #fff;
            border-radius: 27px;
            font-size: 18px;
            border: none;
            cursor: pointer;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/Login/MerchantInfo.vue